import { render, staticRenderFns } from "./areaManager.vue?vue&type=template&id=0a4f5ec4&scoped=true"
import script from "./areaManager.vue?vue&type=script&lang=js"
export * from "./areaManager.vue?vue&type=script&lang=js"
import style0 from "./areaManager.vue?vue&type=style&index=0&id=0a4f5ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f5ec4",
  null
  
)

export default component.exports